import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, FormLabel, FormGroup, TextField, Tooltip, IconButton, Icon } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useLocation, Link } from 'react-router-dom';

import Loader from '../../common/loader';
import Crud from '../../common/crud';
import NotFound from '../../common/not-found';
import Trash from '../../common/trash';

import AuthContext from '../../context';
import { del, get, post, put } from '../../utils/api-services';
import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    tableContainer: {
        width: '100%',
    }
}));

const UserSedes = () => {

    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const classes = useStyles();
    const { pathname } = useLocation();
    const [state, setState] = useState({
        loading: true,
        users: [],
        sedes: [],
        usedes: [],
        usede: {
            iduser_sede: 0,
            user: {},
            sede: {}
        },
        permissions: {}
    });

    useEffect(() => {
        window.document.title = 'User sede';

        validatePermissions();
    }, []);

    const validatePermissions = () => {
        const permissions = helpers.getPermissions(pathname);
        setState(prev => ({ ...prev, permissions }));

        (permissions.read_attr) ? makeRequest() : setState(prev => ({ ...prev, loading: false }));
    }

    const makeRequest = async () => {
        showLoader(true);
        const response = await get('/userSedes');
        if (response.status === 200) {
            setState(prev => ({
                ...prev,
                loading: false,
                usedes: response?.data ?? [],
                users: response?.users ?? [],
                sedes: response?.sedes ?? [],
                usede: {
                    sede: response?.sedes[0],
                    user: response?.users[0]
                }
            }));
        } else {
            console.log('[UserSedes] makeRequest error', response);
            helpers.failRequest(response, showToast, signOut)
        }
        showLoader(false);
    }

    const validateForm = (option) => {
        const { iduser_sede, user, sede } = state.usede;

        switch (option) {
            case 'update':
                const data = state.usedes.filter(value => value.iduser_sede === iduser_sede);

                if (data[0]) {
                    const before = JSON.stringify(data[0]);
                    const after = JSON.stringify(state.usede);
                    if (before !== after) {
                        if (user.id && sede.id) {
                            return true;
                        } else {
                            showToast('All fields is required', 'error');
                            return false;
                        }
                    } else {
                        showToast('Update some field', 'error');
                        return false;
                    }
                } else {
                    showToast('Select some row', 'error');
                    return false;
                }

            case 'store':
                if (user.id && sede.id) {
                    return true;
                } else {
                    showToast('All fields is required', 'error');
                    return false;
                }

            case 'delete':
                if (iduser_sede === 0) {
                    showToast('Select some row', 'error');
                    return false;
                }
                const cond = window.confirm(`Are you sure you want to delete this row?`);

                return Boolean(iduser_sede && cond);
            default:
                break;
        }
    }

    const clear = () => setState(prev => ({
        ...prev,
        usede: {
            ...prev.sede,
            iduser_sede: 0,
            user: prev.users[0],
            sede: prev.sedes[0]
        }
    }));

    const store = async () => {
        const cond = validateForm('store');
        if (cond) {
            showLoader(true);
            const response = await post('/userSede/store', state.usede);
            if (response.status === 200) {
                setState(prev => ({ ...prev, usedes: response?.data ?? prev.usedes }));
                showToast(response.message);
            } else {
                console.log('[UserSedes] store error', response);
                helpers.failRequest(response, showToast, signOut);
                showLoader(false);

                return false
            }
            showLoader(false);
        }

        return cond;
    }

    const update = async () => {
        const { iduser_sede } = state.usede;
        const cond = validateForm('update');

        if (cond) {
            showLoader(true);
            const response = await put(`/userSede/${iduser_sede}/update`, state.usede);
            if (response.status === 200) {
                setState(prev => ({ ...prev, usedes: response?.data ?? prev.usedes }));
                showToast(response.message);
            } else {
                console.log('[UserSedes] update error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const destroy = async () => {
        const { iduser_sede } = state.usede;
        const cond = validateForm('delete');

        if (cond) {
            showLoader(true);
            const response = await del(`/userSede/${iduser_sede}`);
            if (response.status === 200) {
                setState(prev => ({ ...prev, usedes: response?.data ?? prev.usedes }));
                showToast(response.message);
            } else {
                console.log('[UserSedes] destroy error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const valueGetter = params => params.value.name;

    const renderCell = ({ row }) => {
        return (
            <Link to={`/history/user_sedes/${row.iduser_sede}`} target='_blank'>
                <Tooltip title='Show history' placement='top'>
                    <IconButton>
                        <Icon>{'history'}</Icon>
                    </IconButton>
                </Tooltip>
            </Link>
        );
    }

    const columns = [
        { field: 'user', headerName: 'User', flex: 1, valueGetter },
        { field: 'sede', headerName: 'Sede', flex: 1, valueGetter },
        { field: 'actions', headerName: 'Actions', flex: 0.5, renderCell }
    ];

    if (state.loading) {
        return <Loader />;
    }
    if (!state.permissions.read_attr) {
        return <NotFound />;
    }

    return (
        <div className={classes.root}>
            <h1>{'Users sedes'}</h1>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <FormGroup>
                        <FormLabel>{'User'}</FormLabel>

                        <Autocomplete
                            options={state.users}
                            value={state.usede.user}
                            getOptionLabel={user => user?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(event, user) => {
                                console.log(user)
                                setState(prev => ({ ...prev, usede: { ...prev.usede, user } }));
                            }}
                            renderInput={params => <TextField {...params} placeholder='User' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormGroup>
                        <FormLabel>{'Sede'}</FormLabel>

                        <Autocomplete
                            options={state.sedes}
                            value={state.usede.sede}
                            getOptionLabel={sede => sede?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(event, sede) => {
                                setState(prev => ({ ...prev, usede: { ...prev.usede, sede } }));
                            }}
                            renderInput={params => <TextField {...params} placeholder='Sede' />}
                        />
                    </FormGroup>
                </Grid>
            </Grid>

            <Crud
                permissions={state.permissions}
                create={{ create: clear, store }}
                update={update}
                destroy={destroy}
                cancel={clear}
            />

            {
                state.permissions.delete_attr &&
                <Trash table='user_sedes' id='iduser_sede' onRefresh={makeRequest} />
            }

            <div className={classes.tableContainer}>
                <DataGrid
                    rows={state.usedes}
                    columns={columns}
                    pageSize={45}
                    density='compact'
                    autoHeight
                    getRowId={row => row.iduser_sede}
                    onRowClick={({ row }) => setState(prev => ({ ...prev, usede: row }))}
                />
            </div>
        </div>
    );
}

export default UserSedes;